<template>
  <div style="transition: width 0.2s;" class="text-white fill-white overflow-x-hidden overflow-y-auto scrollbar-thin scrollbar-thumb-blue-800 scrollbar-track-blue-200" :class="{'w-16': collapsed, 'w-60': !collapsed, 'hidden-menu': collapsed, 'hidden-menu-end': linkJustifyCenter}">
    <div class="w-full flex" :class="{'ml-2': !linkJustifyCenter, 'justify-center': linkJustifyCenter}" v-if="collapse">
      <svg class="mb-6 w-6 h-6 fill-white cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" @click.prevent="collapsedMenu = !collapsedMenu;"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
    </div>
    <div class="mt-1 mb-4 text-center whitespace-nowrap overflow-hidden" v-if="!collapsed">
      {{ user.name }}
    </div>
    <main-menu-item label="Agenda geral" icon="fa-calendar-day" link="/appointments" :selected="isUrl('appointments') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Grupos de atendimento" icon="fa-laptop-medical" link="/groups" :selected="isUrl('groups') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Especialidades" icon="fa-suitcase-medical" link="/specialties" :selected="isUrl('specialties') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Profissional de saúde" icon="fa-user-doctor" link="/professionals" :selected="isUrl('professionals') ? true : false" />
    <main-menu-item label="Gestão de cuidados" icon="fa-users" link="/patients" :selected="isUrl('patients') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Formulários" icon="fa-clipboard" link="/forms" :selected="isUrl('forms') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Alimentos" icon="fa-bowl-food" link="/foods" :selected="isUrl('foods') ? true : false" />
    <main-menu-item v-if="user.role == 2" label="Ações" icon="fa-bullseye" link="/goals" :selected="isUrl('goals') ? true : false" />
    <main-menu-item v-if="user.role == 2" label="Metas de cuidados" icon="fa-chart-line" link="/meta" :selected="isUrl('meta') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Carboidratos" icon="fa-scale-unbalanced" link="/carbs" :selected="isUrl('carbs') ? true : false" />
    <main-menu-item label="Dicas de saúde" icon="fa-clipboard-list" link="/health-tips" :selected="isUrl('health-tips') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Termos de uso" icon="fa-regular fa-file-lines" link="/terms" :selected="isUrl('terms') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="CID/CIAP" icon="fa-capsules" link="/cid" :selected="isUrl( 'cid' ) ? true : false" />
    <main-menu-item label="Perfil" icon="fa-user" link="/profile" :selected="isUrl('profile') ? true : false" />
    <main-menu-item label="Sair" icon="fa-right-from-bracket" link="/logout" :selected="false" method="delete" as="button" />
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import MainMenuItem from '@/Shared/MainMenuItem'
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Icon,
    MainMenuItem,
    Link,
  },
  props: {
    collapse:  {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collapsedMenu: false,
      linkJustifyCenter: false,
    }
  },
  computed: {
    collapsed: function () {
      return this.collapse && this.collapsedMenu;
    }
  },
  watch: {
    collapsedMenu(newValue) {
      localStorage.collapsedMenu = newValue;
      setTimeout(function() {
        this.linkJustifyCenter = this.collapsedMenu;
      }, 200);
    }
  },
  mounted() {
    if (typeof(localStorage.collapsedMenu) == "string") {
      this.collapsedMenu = JSON.parse(localStorage.collapsedMenu) === true;
    }
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
}
</script>
<style>
  .hidden-menu-end a,
  .hidden-menu-end button {
    @apply px-0 justify-center;
  }
  .hidden-menu a span,
  .hidden-menu button span {
    display: none;
  }
  .hidden-menu a svg,
  .hidden-menu button svg {
    @apply mr-0;
  }
</style>
